export default "__VITE_ASSET__Efg428OS__"